/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GenderFemaleIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Gender Female',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="18" cy="3.685" r="3.685" />
    <path
      d="m12.861 13.247.518 6.039-4.108 7.068a.558.558 0 0 0 .537.712h4.215l1.654 8.485a.555.555 0 0 0 .545.449h3.557a.555.555 0 0 0 .545-.449l1.654-8.485h4.215a.558.558 0 0 0 .537-.712l-4.07-7.068.487-6.056a3.873 3.873 0 0 0-1.829-3.745A3.933 3.933 0 0 0 19.421 9h-2.842a3.934 3.934 0 0 0-1.89.482 3.87 3.87 0 0 0-1.828 3.765Z"
    />
  </svg>`;
};
